module.exports = __webpack_public_path__ + "media/roast_story.1cb15053.mp4";